export enum TemporalComparison {
  Date1BeforeDate2 = -1,
  Time1BeforeTime2 = -1,
  Date1EqualDate2 = 0,
  Time1EqualTime2 = 0,
  Date1AfterDate2 = 1,
  Time1AfterTime2 = 1,
}
